import { fabric } from 'fabric';
import { getState, modifyState } from '~src/state';

export const showCursor = () => {
  const cursorCanvas = getState('cursorCanvas');
  const mouseCursor = getState('mouseCursor');
  mouseCursor.set('visible', true);
  cursorCanvas.renderAll();
};

export const hideCursor = () => {
  const cursorCanvas = getState('cursorCanvas');
  const mouseCursor = getState('mouseCursor');
  mouseCursor.set('visible', false);
  cursorCanvas.renderAll();
};

export const setCursorRadius = (val) => {
  const cursorCanvas = getState('cursorCanvas');
  const mouseCursor = getState('mouseCursor');

  mouseCursor.set('radius', val);
  cursorCanvas.renderAll();
};

export const initCursorCanvas = ({ width, height }) => {
  const cursorCanvas = new fabric.StaticCanvas('cursor-canvas', {
    width,
    height,
  });

  const cursorOpacity = 0.3;

  const mouseCursor = new fabric.Circle({
    left: 0,
    top: 0,
    radius: 0,
    fill: 'rgba(255, 255, 255,' + cursorOpacity + ')',
    stroke: 'black',
    originX: 'center',
    originY: 'center',
    scaleX: 1,
    scaleY: 1,
    visible: false,
  });

  cursorCanvas.add(mouseCursor);

  window.canvas.on('mouse:move', function (evt) {
    const mouse = this.getPointer(evt.e);
    mouseCursor
      .set({
        top: mouse.y,
        left: mouse.x,
      })
      .setCoords();

    window.cursorCanvas.renderAll();
  });

  modifyState('mouseCursor', mouseCursor);
  modifyState('cursorCanvas', cursorCanvas);

  window.cursorCanvas = cursorCanvas;
};
